import { Component, OnInit, Input, ViewEncapsulation, ChangeDetectionStrategy, TemplateRef, Output, EventEmitter } from '@angular/core';
import { slideInOut } from '@shared/animations/slide-in-out';
import { CldSourceMediaSize } from '../cld-picture/cld-picture.interface';
import { UsersService } from '@shared/services/users/users.service';
import { UserInfo } from 'app/shared/services/users/types/user-info';
import { Observable } from 'rxjs';
import { UserRolesEnum } from '@collections/users/enums/user-roles.enums';
import { Platform } from '@angular/cdk/platform';
import { NgTemplateOutlet } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { RenderIfDirective } from '../../directives/render-if.directive';
import { RouterLink } from '@angular/router';
import { CldPictureComponent } from '../cld-picture/cld-picture.component';
import { NgClass } from '@angular/common';

@Component({
    selector: 'card-block',
    templateUrl: './card-block.component.html',
    styleUrls: ['./card-block.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [slideInOut],
    standalone: true,
    imports: [CldPictureComponent, RouterLink, RenderIfDirective, MatIcon, NgTemplateOutlet, NgClass]
})
export class CardBlockComponent implements OnInit {
  hovered = false;
  @Input() id: string;
  @Input() image: string;
  @Input() imageSizes: CldSourceMediaSize[];
  @Input() lazyLoadImage: boolean;
  @Input() type: string;
  @Input() title: string;
  @Input() url: string;
  @Input() text: string;
  @Input() views = 0;
  @Input() isAccessibleForFree: boolean;
  @Input() itemIndex = 0;
  @Input() footerTpl: TemplateRef<any>;
  @Input() fallbackImage: string;
  @Input() state: any;
  @Input() seeAll: boolean;
  @Output() onItemSelected: EventEmitter<any> = new EventEmitter();
  user$: Observable<UserInfo>;
  UserRolesEnum = UserRolesEnum;

  constructor(
    private usersService: UsersService,
    private platform: Platform
  )
  { }

  ngOnInit(): void {
    // da valutare
    // if(!this.platform.isBrowser) {
    this.lazyLoadImage = true;
    // }

    this.user$ = this.usersService.onUserChange

  }

  itemSelected(): void {
    this.onItemSelected.emit();
  }

}
